import Button from '@dd3tech/wiggui/Button'
import Flex from '@dd3tech/wiggui/Flex'
import Modal from '@dd3tech/wiggui/Modal'
import OptionButton from '@dd3tech/wiggui/OptionButton'
import Text from '@dd3tech/wiggui/Text'
import { MdHighlightOff, MdSupportAgent } from 'react-icons/md'
import { useModalBrokerInvitationStore } from '../../../../../../store/modals-services/modal-broker-invitation'
import { useWhatsapp } from '../../../../../../hooks'
import { WHATSAPP_WIGGOT_CUSTOMER_SUPPORT } from '../../../../../../constants'
import { createUrlMedia } from '@wiggot/utils'
import Avatar from '@dd3tech/wiggui/Avatar'
import { useModalBrokerInvitation } from '../../useModalBrokerInvitation'

export const Rejected = () => {
  const invitationData = useModalBrokerInvitationStore(
    (state) => state.invitationData
  )
  const { redirectToWhatsapp } = useWhatsapp()

  const { onCloseModal, permanentHiddenModal } = useModalBrokerInvitation()

  const handleHelpClick = () => {
    redirectToWhatsapp({
      openInNewTab: true,
      phone: WHATSAPP_WIGGOT_CUSTOMER_SUPPORT,
      text: 'Hola. Necesito ayuda para formar parte de una agencia.'
    })
  }

  const logoUrl = invitationData?.logo
    ? createUrlMedia({
        id: invitationData?.logo
      })
    : undefined

  return (
    <>
      <Modal.Body>
        <Flex dir="col" items="center" justify="start" gap="gap-6" wFull>
          <Flex dir="row" items="center" justify="between" gap="gap-3" wFull>
            <div className="relative">
              <Avatar
                containerClassName="rounded-full min-w-[40px] min-h-[40px] w-10 h-10"
                avatarUrl={logoUrl}
                fullName={invitationData?.agencyName}
              />
              <div className="absolute bottom-0 right-0 bg-notif-red rounded-full w-[18px] h-[18px] flex items-center justify-center">
                <MdHighlightOff className="text-white min-w-[16px] min-h-[16px]" />
              </div>
            </div>
            <OptionButton
              onClick={handleHelpClick}
              variant="gray"
              rightIcon={
                <MdSupportAgent className="text-secondary min-w-[20px] min-h-[20px]" />
              }
            >
              <span className="underline text-secondary">Ayuda</span>
            </OptionButton>
          </Flex>
          <Flex dir="col" items="center" justify="start" gap="gap-6" wFull>
            <Text className="text-headline-s text-primary font-semibold text-left w-full">
              Tu solicitud fue rechazada
            </Text>
            <Text className="text-secondary text-body-m text-left w-full">
              No te preocupes, continúa como agente independiente y disfruta de
              tu prueba gratuita para conocer las herramientas de Wiggot.
            </Text>
            <Text className="text-secondary text-body-bold-m text-left w-full">
              Si tienes dudas contáctanos para recibir ayuda.
            </Text>
          </Flex>
        </Flex>
      </Modal.Body>
      <Modal.Footer className="flex-row flex py-3 border-t gap-3 border-surface-strokes items-center w-full px-6 justify-between">
        <Button
          fullWidth
          variant="secondary"
          onClick={(event) => {
            event.stopPropagation()
            permanentHiddenModal()
            onCloseModal()
          }}
        >
          Continuar
        </Button>
      </Modal.Footer>
    </>
  )
}
